export default "__VITE_ASSET__CBGkJgWz__"